<template>
  <div class="side-panel">
    <div :class="{ 'overlay': true, 'animated': animated }" v-on:click="onClosePanel"></div>
    <div class="content">
      <div
        class="inner-content"
        :class="[{'animated': animated}, `side-panel-${background}`]"
      >
        <div class="side-panel-top">
          <span class="side-panel-top-left"> 
            <slot name="backButton">
              <button class="btn-link close" v-on:click="onClosePanel"><i class="fas fa-times"></i> Close</button>
            </slot>
            <slot name="topContentLeft">
            </slot>
          </span> 
          <slot name="topContent"></slot>
        </div>
        <div id="scrollTarget">
          <h3 v-if="title">{{ title }}</h3>
          <slot>
            <loader :wrapperStyle="loaderWrapperStyle" />
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../components/loader';

export default {
  props: {
    onClose: {
      type: Function,
      default: function() {
        return;
      },
    },
    background: {
      type: String,
      require: false,
      default: 'white'
    },
    title: String
  },

  components: {
    Loader
  },

  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
    setTimeout(function() {
      this.animated = true;
    }.bind(this), 10);
  },

  beforeDestroy() {
    document.querySelector('body').style.overflow = '';
  },

  data: function() {
    return {
      loaderWrapperStyle: {
        position: 'absolute',
        top: '50%',
        left:'50%'
      },
      animated: false
    }
  },

  methods: {
    onClosePanel: function() {
      this.animated = false;
      document.querySelector('body').style.overflow = '';
      setTimeout(() => {
        this.onClose();
      }, 400);
    }
  }
}
</script>